import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyVirtualFolders = (
  data: IPropertyDetailsResponse
): { dropbox?: string; google_drive?: string } => {
  return {
    dropbox: data?.dropbox_link || undefined,
    google_drive: data?.google_drive_link || undefined
  };
};

export type IPropertyDetailVirtualFolders = {
  dropbox?: string;
  google_drive?: string;
};
